export default {
  name: 'biosphere',
  key: 'biosphere',
  attributes: {
    remnant: {
      key: 'remnant',
      name: 'biosphere.remnant',
    },
    microbial: {
      key: 'microbial',
      name: 'biosphere.microbial',
    },
    none: {
      key: 'none',
      name: 'biosphere.none',
    },
    humanMiscible: {
      key: 'humanMiscible',
      name: 'biosphere.humanMiscible',
    },
    immiscible: {
      key: 'immiscible',
      name: 'biosphere.immiscible',
    },
    hybrid: {
      key: 'hybrid',
      name: 'biosphere.hybrid',
    },
    engineered: {
      key: 'engineered',
      name: 'biosphere.engineered',
    },
  },
};
